import Panel from './Panel';

const PrimaryFilledPanel = (props) => {
    return <Panel {...props} type="filled" />;
};

export default PrimaryFilledPanel;
